"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SliderModal = require("./SliderModal");
Object.keys(_SliderModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SliderModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SliderModal[key];
    }
  });
});